import { ReactElement } from 'react';
import { useUpdateEffect } from 'react-use';

import {
   AppointmentDetailsQuery,
   AppointmentSlotScheduleQuery,
   AppointmentUpdatePatientPresenceCommand,
} from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';

import { Toggle } from '@dreryk/react-components';
import { useFormController } from '@dreryk/react-common';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';

const DEFAULT_PATIENT_PRESENCE_STATUS = false;

type PatientPresenceStatusToggleFormBean = {
   patientPresent: boolean;
};

type PatientPresenceStatusToggleProps = {
   initialPatientPresent: boolean | undefined;
   appointmentId: number;
};

export const PatientPresenceStatusToggle = (props: PatientPresenceStatusToggleProps): ReactElement => {
   const { register, watch } = useFormController<PatientPresenceStatusToggleFormBean>({
      patientPresent: props.initialPatientPresent ?? DEFAULT_PATIENT_PRESENCE_STATUS,
   });

   const currentPatientPresent = watch('patientPresent');

   const { execute: updateAppointmentConfirmationStatus } = useCqrsCommand<void, PatientPresenceStatusToggleFormBean>(
      (parameters) => {
         const command = new AppointmentUpdatePatientPresenceCommand();
         command.patientPresence = parameters.patientPresent ? 'PRESENT' : 'UNKNOWN';
         command.appointmentId = AppointmentId.of(props.appointmentId);
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(AppointmentDetailsQuery);
            refetchCqrsQuery(AppointmentSlotScheduleQuery);
         },
      }
   );

   useUpdateEffect(() => {
      updateAppointmentConfirmationStatus({ patientPresent: currentPatientPresent });
   }, [currentPatientPresent]);

   // TODO DREGAB-24646 Zmienić na <form onInput ...>...</form>
   return <Toggle testId={'patientPresenceStatus'} controller={register('patientPresent')} />;
};
